// Module
var code = "<ul class=\"im-contact-group-detail\"> <li class=\"im-contact-group-detail-header\"> <p class=\"im-backto-contactlist\"> <i class=\"im-back-icon\">&nbsp;</i> </p> <p class=\"im-contact-group-msg\"></p> </li> <li class=\"im-contact-group-detail-body\"></li> </ul>";
// Exports
module.exports = code;